import PropTypes from 'prop-types';
import withSeriesType from './components/WithSeriesType'; // Main provider

export { HighchartsProvider } from './components/WithHighcharts'; // Graphs

export { default as HighchartsChart } from './components/HighchartsChart';
export { default as HighchartsSparkline } from './components/HighchartsSparkline';
export { default as Highcharts3dChart } from './components/Highcharts3dChart'; // Graph parts

export { default as Annotation } from './components/Annotation';
export { default as Caption } from './components/Caption';
export { default as Chart } from './components/Chart';
export { default as ColorAxis } from './components/ColorAxis';
export { default as Credits } from './components/Credits';
export { default as Loading } from './components/Loading';
export { default as Legend } from './components/Legend';
export { default as Pane } from './components/Pane';
export { PlotBand, PlotLine } from './components/PlotBandLine';
export { default as Subtitle } from './components/Subtitle';
export { default as Title } from './components/Title';
export { default as Tooltip } from './components/Tooltip';
export { default as XAxis } from './components/XAxis';
export { default as YAxis } from './components/YAxis';
export { default as ZAxis } from './components/ZAxis';
var axisNotRequired = {
  requiresAxis: false
};
var hasParentSeries = {
  baseSeries: PropTypes.string.isRequired
}; // Series

export var AreaRangeSeries = withSeriesType('AreaRange');
export var AreaSeries = withSeriesType('Area');
export var AreaSplineRangeSeries = withSeriesType('AreaSplineRange');
export var AreaSplineSeries = withSeriesType('AreaSpline');
export { default as BarSeries } from './components/BarSeries';
export var BellCurveSeries = withSeriesType('BellCurve', {}, hasParentSeries);
export var BoxPlotSeries = withSeriesType('BoxPlot');
export var BubbleSeries = withSeriesType('Bubble');
export var BulletSeries = withSeriesType('Bullet');
export var ColumnPyramidSeries = withSeriesType('ColumnPyramid');
export var ColumnRangeSeries = withSeriesType('ColumnRange');
export var ColumnSeries = withSeriesType('Column');
export var CylinderSeries = withSeriesType('Cylinder');
export var DependencyWheelSeries = withSeriesType('DependencyWheel');
export var ErrorBarSeries = withSeriesType('ErrorBar');
export var FunnelSeries = withSeriesType('Funnel', axisNotRequired);
export var Funnel3dSeries = withSeriesType('Funnel3d');
export var GaugeSeries = withSeriesType('Gauge');
export var HeatmapSeries = withSeriesType('Heatmap');
export var HistogramSeries = withSeriesType('Histogram', {}, hasParentSeries);
export var ItemSeries = withSeriesType('Item');
export var LineSeries = withSeriesType('Line');
export var NetworkGraphSeries = withSeriesType('NetworkGraph');
export var PackedBubbleSeries = withSeriesType('PackedBubble', axisNotRequired);
export var ParetoSeries = withSeriesType('Pareto', {}, hasParentSeries);
export var PieSeries = withSeriesType('Pie', axisNotRequired);
export var PolygonSeries = withSeriesType('Polygon');
export var PyramidSeries = withSeriesType('Pyramid', axisNotRequired);
export var Pyramid3dSeries = withSeriesType('Pyramid3d');
export var SankeySeries = withSeriesType('Sankey');
export var OrganizationSeries = withSeriesType('Organization');
export var ScatterSeries = withSeriesType('Scatter');
export var Scatter3dSeries = withSeriesType('Scatter3d');
export var SolidGaugeSeries = withSeriesType('SolidGauge');
export var SplineSeries = withSeriesType('Spline');
export var StreamGraphSeries = withSeriesType('StreamGraph');
export var SunburstSeries = withSeriesType('Sunburst');
export var TilemapSeries = withSeriesType('Tilemap');
export var TimelineSeries = withSeriesType('Timeline');
export var TreemapSeries = withSeriesType('Treemap');
export var VariablePieSeries = withSeriesType('VariablePie', axisNotRequired);
export var VariwideSeries = withSeriesType('Variwide');
export var VennSeries = withSeriesType('Venn', axisNotRequired);
export var VectorSeries = withSeriesType('Vector');
export var WaterfallSeries = withSeriesType('Waterfall');
export var WindBarbSeries = withSeriesType('WindBarb');
export var XRangeSeries = withSeriesType('XRange'); // Hooks

export { default as useHighcharts } from './components/UseHighcharts';
export { default as useChart } from './components/UseChart';
export { default as useAxis } from './components/UseAxis';
export { default as useSeries } from './components/UseSeries';
export { default as usePlotBandLine } from './components/UsePlotBandLine'; // utility hooks, not part of api

export { default as useModifiedProps } from './components/UseModifiedProps'; // Helpers

export { default as withHighcharts } from './components/WithHighcharts';
export { default as Axis } from './components/Axis';
export { default as BaseChart } from './components/BaseChart';
export { default as Debug } from './components/Debug';
export { default as Series } from './components/Series'; // Utils

export { getNonEventHandlerProps } from './utils/events';
export { getEventsConfig } from './utils/events';
export { withSeriesType };